{
  "version": 1,
  "asset_id": "22dc7c71-a90c-40d5-a500-51d0fbaed499",
  "project_id": "81e5f51e-81a3-47ad-9e0d-7249ca4c0a70",
  "url": "/__l5e/assets-v1/22dc7c71-a90c-40d5-a500-51d0fbaed499/apple-pay.svg",
  "r2_key": "a/v1/81e5f51e-81a3-47ad-9e0d-7249ca4c0a70/22dc7c71-a90c-40d5-a500-51d0fbaed499/apple-pay.svg",
  "original_filename": "apple-pay.svg",
  "size": 1609,
  "content_type": "image/svg+xml",
  "created_at": "2026-08-30T15:11:33Z"
}
